import styled from 'styled-components';
import Input from 'components/common/Input';
import SubmitButton from '../devise/common/SubmitButton';

export const InputStyled = styled(Input)``;

export const Label = styled.label`
  display: inline-block;
  margin: 1rem 0 0.5rem 0;
`;

export const Container = styled.div`
  margin-top: 1rem;

  @media (max-width: 500px) {
    max-width: 80vw;
  }
`;

export const InternalForm = styled.form`
  margin-bottom: 1rem;
`;

export const ButtonStyled = styled(SubmitButton)`
  margin: auto;
  white-space: nowrap;
`;

export const InputGroup = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;
